import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { clearImpersonation } from '../../store/user/userSlice';
import { Button } from 'src/design-system';
export function ImpersonationBanner() {
  const dispatch = useDispatch();
  const impersonatedUser = useSelector((state: RootState) => state.auth.impersonatedUser);
  if (!impersonatedUser) {
    return null;
  }
  const displayName =
    [impersonatedUser.firstName, impersonatedUser.lastName].filter(Boolean).join(' ') ||
    impersonatedUser.email;
  return (
    <div className="shrink-0 z-[60] bg-amber-500 text-black px-4 py-1.5 flex items-center justify-between shadow-md">
      <span className="font-medium text-sm">
        Viewing as: {displayName} ({impersonatedUser.email})
      </span>
      <Button
        size="sm"
        variant="tertiary"
        className="bg-black/20 hover:bg-black/30 text-black font-medium"
        onPress={() => {
          dispatch(clearImpersonation());
          window.location.reload();
        }}>
        Exit
      </Button>
    </div>
  );
}
